<script lang="ts">
export default {
    name: "Viewer",
};
</script>
<script setup lang="ts">
import useTimeout from 'vue-cesium/es/composables/private/use-timeout'
import { onUnmounted, onMounted } from "vue"
import { store } from '@/store'
import { useRoute } from 'vue-router'
import { EModeCode, EDockModeCode, EGear } from '@/types/device'
import {
    VcCompassProps,
    VcConfigProvider,
    VcMyLocationProps,
    VcPrintProps,
    VcViewerRef,
    VcZoomControlProps,
    VcPrimitive,
    VcGeometryPolygon,
    VcGeometryInstance,
} from 'vue-cesium'
import { VcReadyObject } from 'vue-cesium/es/utils/types'
import { emitter } from '@/utils/events'
// import VcRenderAirportLayer from '../render-airport-layer/index.vue'
import { getStaticData, getShipInfoMarkList, getnavigationMarkList, clickAlert, getNearbyList } from "@/api/Local/index"
// import * as api from "@/api";
import { useConnectWebSocket } from "@/utils/use-connect-websocket";
import { DeviceTypeName, EBizCode } from "@/types/enum";
import closePng from "@/assets/images/close.png"
import { useFormatDate } from "@/hooks/userHookDate"
import PhotoPop from "../photo-pop/index.vue"
import AlertPop from "../alert-pop/index.vue"
import GengcundouBridgeLayer from "./gengcundou-bridge-layer.vue"
import WaylineWaypointsLayer from "./wayline-waypoints-layer.vue"
import { getDeviceTopo1 } from "@/api/monitorApi/index"
import { flyToCamera } from 'vue-cesium/es/utils/cesium-helpers'
defineOptions({
    name: 'VcDemoViewer'
})

const { loadDefaultLayers, toggle } = store.viewer.useLayerStore()
const route = useRoute()
const useDate = useFormatDate()
const cesiumPath = "/Cesium/Cesium.js"
const accesstToken =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0M2ZmNWUzNS0zNGE4LTQzOGYtYmFhZC0yN2I4NWNmOTJiZjgiLCJpZCI6MTcyODkzLCJpYXQiOjE2OTc3ODYyNzV9.BHzl_1hlzAj6SnIzMtjoxyG_U1p66i3Uoz1EJZ4HDwg'
// emit
const emit = defineEmits(['viewerReady', 'cesiumReady', 'leftClick', 'destroyed'])
const viewerRef = ref<VcViewerRef>()
const showCredit = ref(false)

const layerListSelect = ref(true)

const limitHeightChecked = ref(false)

const noFlyChecked = ref(false)

const layerChecked = ref(true)

const lengedActive = ref(true)

const roadActive = ref(true)

const shippingActive = ref(false)

// 机场状态
const dockInfo = computed(() => store.other.useMyStore().getDockInfo)

// computed
const layerList = computed(() => [
    ...store.viewer.useLayerStore().baseLayers,
    ...store.viewer.useLayerStore().overlayLayers
])
const terrainLayers = computed(() => store.viewer.useLayerStore().terrainLayers)
const indicatorImage3 = '/images/dianwei.png'
const ossMarkImage = "/images/hangbiao-pic.png"
const airBliledImg = "/images/jichang-bj.png"
const warningImage = '/images/yujing-icon.png'
//水波纹
const riverArray = ref()
const riverAppearance = shallowRef();
const riverVertexFormat = shallowRef();

/**
 *    初始化水波纹函数
 */
const initXianRiver = () => {
    getStaticData('/datas/ripple/ripple_data.json').then(res => {
        riverArray.value = res.features
        initRiver(Cesium); //河流
    })
}

const initRiver = (Cesium: VcReadyObject["Cesium"]) => {
    riverAppearance.value = new Cesium.EllipsoidSurfaceAppearance({
        material: new Cesium.Material({
            fabric: {
                type: "Water",
                uniforms: {
                    normalMap: '/images/waterNormals.jpg',
                    frequency: 1000.0,
                    animationSpeed: 0.01,
                    amplitude: 10.0,
                    // 水体颜色
                    baseWaterColor: Cesium.Color.DODGERBLUE,
                    // 镜面反射强度
                    specularIntensity: 0.8
                },
            },
        }),
    });
    riverVertexFormat.value = Cesium.EllipsoidSurfaceAppearance.VERTEX_FORMAT;
};

const qdhRiver = async () => {
    const options = {
        camera: readyViewer.value.scene.camera,
        canvas: readyViewer.value.scene.canvas,
    };
    const dataSource = await readyViewer.value.dataSources.add(
        Cesium.KmlDataSource.load("/datas/千岛湖水面区域.kml", options)
    );
}

const shipImage = "/images/bond-up2.png"
const shipEntityRef = ref()
const shipMarkers = ref()
const shipShow = ref(true)

const shipList = ref()
const shipActive = ref(false)

async function ShipInfoMarkList() {
    const params = {} as any;
    params.lngLeft = 119.5
    params.latLeft = 30.7
    params.lngRight = 122
    params.latRight = 32
    const result = await getShipInfoMarkList(params)
    shipMarkers.value = result.list
}
const theEDockModeCode = reactive(['已断开', '空闲中', '调试中', '远程调试', '升级中', '运行中'])
const airOptions: any = ref({})
async function getOnlineTopo() {
    const params: any = {}
    params.page = 1
    params.size = 999
    params.domain = [3]
    // params.provinceCode = import.meta.env.VITE_APP_AREACODE,
    //   params.cityCode = organizationData.value.cityCode,
    //   params.areaCode = organizationData.value.areaCode,
    //   params.orgId = organizationData.value.provinceCode,
    await getDeviceTopo1(params).then((res) => {
        if (res.list && res.list.length) {
            airOptions.value = res.list
        }
    })
}


const handleBillboardClick = (event: any) => {
    // 处理点击事件
    console.log('Billboard clicked', event);
    shipActive.value = true
    shipList.value = event
};

const closeBtn = () => {
    shipActive.value = false
}

const formatTimestamp = (timestamp: any) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
};

const shipShowBtn = () => {
    if (shipShow.value) {
        shipShow.value = false
        for (let i = 0; i < shipEntityRef.value.length; i++) {
            shipEntityRef.value[i].unload()
        }
    } else {
        shipShow.value = true
        for (let i = 0; i < shipEntityRef.value.length; i++) {
            shipEntityRef.value[i].reload()
        }
    }
}

const polygonList: any = shallowRef([])
const lineList: any = shallowRef([])
const markerList: any = shallowRef([])
const navigationShow = ref(false)
const navigationEntityRef = ref()
const markEntityRef = ref()
//航标
async function navigationMarkList() {
    const params = {
        waylineId: "",
    } as any;
    const result = await getnavigationMarkList(params)
    // lineList.value = result.list
    lineList.value = []
    polygonList.value = []
    markerList.value = []
    result.list.map((data: any) => {
        if (data.markType != 3) {
            polygonList.value.push(JSON.parse(data.polygonPoints))
            lineList.value.push(data)
        } else {
            markerList.value.push(data)
        }
    })
}
const markerActive = ref(false)
const navigationShowBtn = () => {
    markerActive.value = true
    if (!navigationShow.value) {
        if (markEntityRef.value && markEntityRef.value.length) {
            markEntityRef.value[0].unload()
        }
        for (let i = 0; i < navigationEntityRef.value.length; i++) {
            navigationEntityRef.value[i].unload()
        }
    } else {
        if (markEntityRef.value && markEntityRef.value.length) {
            markEntityRef.value[0].reload()
        }
        for (let i = 0; i < navigationEntityRef.value.length; i++) {
            navigationEntityRef.value[i].reload()
        }
    }
}

const noflyData: any = ref([])
const noflyShow: any = ref(false)
const limitHeighData: any = ref([])
const limitHeighShow: any = ref(false)
const noflyEntityRef = ref()
const limitHeighRef = ref()
// 获取禁飞区限高区json数据
const initNofly = () => {
    getStaticData('/datas/data.json').then((res: any) => {
        noflyData.value = []
        res.forEach((item: any) => {
            const noflyPath: any = []
            const limitHeighPath: any = []
            if (item.shape === 1 && item.height === 0) {
                item.area?.polygon_points[0]?.forEach((point: any) => {
                    noflyPath.push([point[0], point[1]])
                })
            }
            noflyPath.length > 0 && noflyData.value.push(noflyPath)

            if (item.height > 0) {
                item.area?.polygon_points[0].forEach((point: any) => {
                    limitHeighPath.push([point[0], point[1]])
                })
            }
            limitHeighPath.length > 0 && limitHeighData.value.push(limitHeighPath)
        })
    })
}

const noflyBtn = () => {
    if (noflyShow.value) {
        noflyShow.value = false
        if (noflyEntityRef.value && noflyEntityRef.value.length) {
            for (let i = 0; i < noflyEntityRef.value.length; i++) {
                noflyEntityRef.value[i].unload()
            }
        }
    } else {
        noflyShow.value = true
        if (noflyEntityRef.value && noflyEntityRef.value.length) {
            for (let i = 0; i < noflyEntityRef.value.length; i++) {
                noflyEntityRef.value[i].reload()
            }
        }
    }
}

const limitHeighBtn = () => {
    if (limitHeighShow.value) {
        limitHeighShow.value = false
        if (limitHeighRef.value && limitHeighRef.value.length) {
            for (let i = 0; i < limitHeighRef.value.length; i++) {
                limitHeighRef.value[i].unload()
            }
        }
    } else {
        limitHeighShow.value = true
        if (limitHeighRef.value && limitHeighRef.value.length) {
            for (let i = 0; i < limitHeighRef.value.length; i++) {
                limitHeighRef.value[i].reload()
            }
        }
    }
}

const layerCheckedBtn = () => {
    if (layerChecked.value) {
        qdhRiver()
    } else {
        for (let i = readyViewer.value.dataSources.length - 1; i >= 0; i--) {
            readyViewer.value.dataSources.remove(readyViewer.value.dataSources.get(i));
        }
    }
}

// 计算属性来转换正数为负数
const changedNumber = (number: number) => {
    const offectNum = -130 - (number / 2)
    return offectNum
}

const gdToCesium = (lng: any, lat: any, height: any) => {
    // 假设这里的lng和lat是高德地图提供的GCJ-02坐标系下的经度和纬度
    return Cesium.Cartesian3.fromDegrees(lng, lat, height);
}

const airBtn = (item: any) => {
    let orientation
    let position = Cesium.Cartesian3.fromDegrees(item.longitude, item.latitude)
    var header = Cesium.Math.toRadians(invertSign(item.attitude_head) + 30)
    var pitch = Cesium.Math.toRadians(item.attitude_pitch)
    var roll = Cesium.Math.toRadians(item.attitude_roll)
    var hpr = new Cesium.HeadingPitchRoll(header, pitch, roll)
    orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr)
    return orientation
}

const invertSign = (number: number) => {
    return -1 * number;
}

const shrinkActive = ref(false)
const shrinkBtn = () => {
    shrinkActive.value = !shrinkActive.value
}

const markId = ref()
const navigationBtn = (list: any) => {
    if (markId.value != list.markId) {
        markId.value = list.markId
    } else {
        markId.value = null
    }
}

const readyViewer = ref()
const viewerShow = ref(true)
const infoBox = ref(false)
// methods
const onViewerReady = async (readyObj: VcReadyObject) => {
    emit('viewerReady', readyObj)
    loadDefaultLayers(true)
    readyViewer.value = readyObj.viewer
    readyViewer.value.cesiumWidget.screenSpaceEventHandler.removeInputAction(
        Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK
    );
    flyToCamera(
        readyViewer.value,
        {
            //小浦
            // position: Cesium.Cartesian3.fromDegrees(119.840, 31.010, 1000),
            //吕山
            // position: Cesium.Cartesian3.fromDegrees(119.932, 30.910, 1000),
            //丽水
            //千岛湖
            position: Cesium.Cartesian3.fromDegrees(Number(localStorage.getItem("lng")) - 0.0005, Number(localStorage.getItem("lat")) - 0.0115, Number(localStorage.getItem("alt"))),
            heading: 6.283185307179586,
            pitch: -0.5001412827126326,
            roll: 6.283185307179586
        },
    )
    initNofly()
    initXianRiver()
    qdhRiver()
    ShipInfoMarkList()
    navigationMarkList()
    await getOnlineTopo()
    await watch(() => store.other.useMyStore().deviceState, (data, oldVal) => {
        // console.log(data,oldVal)
        if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[data.currentSn]) {
            // console.log('设备状态:', data.deviceInfo)
            if (Object.keys(data.deviceInfo).length) {
                routeList.value = Object.entries(data.deviceInfo).map(([key, value]) => ({
                    key,
                    ...value,
                }));
                routeList.value.forEach((result: any) => {
                    if (result.longitude == 0) {
                        result.longitude = 120.08934239521433
                        result.latitude = 30.25630504251401
                    }
                })
            }
        }
        if (data.currentType === DeviceTypeName.Dock && data.dockInfo[data.currentSn]) {
            // console.log(oldVal,airportList.value)
            // console.log('机场状态:', data.dockInfo[data.currentSn])
            if (!oldVal || !airportList.value) {
                airportList.value = data.dockInfo
            }
        } else if (Object.keys(data.deviceInfo).length == 0) {
            routeList.value = []
            // clearInterval(cameraTimer.value);
        }
    }, {
        immediate: true,
        deep: true
    })
}

const onCesiumReady = (readyObj: any) => {
    emit('cesiumReady', readyObj)
}

watch(() => store.informationListStore.informationStore().orgObj, (data: any, oldVal) => {
    console.log(data)
    if (data && data.lng && readyViewer.value) {
        flyToCamera(
            readyViewer.value,
            {
                position: Cesium.Cartesian3.fromDegrees(data.lng - 0.0005, data.lat - 0.013, 1000),
                heading: 6.283185307179586,
                pitch: -0.5001412827126326,
                roll: 6.283185307179586
            },
        )
    } else if (data == undefined && store.informationListStore.informationStore().areaObj.areaCode == "330522") {
        flyToCamera(
            readyViewer.value,
            {
                position: Cesium.Cartesian3.fromDegrees(119.91676457571826, 30.709040434269302, 15000),
                heading: 6.283185307179586,
                pitch: -0.5001412827126326,
                roll: 6.283185307179586
            },
        )
    }
}, {
    deep: true
})

watch(() => store.informationListStore.informationStore().areaObj, (data: any, oldVal) => {
    console.log(data)
    if (data && readyViewer.value && data.areaCode == "330522") {
        flyToCamera(
            readyViewer.value,
            {
                position: Cesium.Cartesian3.fromDegrees(119.91676457571826, 30.709040434269302, 15000),
                heading: 6.283185307179586,
                pitch: -0.5001412827126326,
                roll: 6.283185307179586
            },
        )
    } else if (data == undefined && store.informationListStore.informationStore().cityObj) {
        flyToCamera(
            readyViewer.value,
            {
                position: Cesium.Cartesian3.fromDegrees(120.02425228626271, 30.545322262052913, 30000),
                heading: 6.283185307179586,
                pitch: -0.5001412827126326,
                roll: 6.283185307179586
            },
        )
    }
}, {
    deep: true
})

watch(() => store.informationListStore.informationStore().cityObj, (data: any, oldVal) => {
    console.log(data)
    if (data && readyViewer.value) {
        flyToCamera(
            readyViewer.value,
            {
                position: Cesium.Cartesian3.fromDegrees(120.02425228626271, 30.545322262052913, 30000),
                heading: 6.283185307179586,
                pitch: -0.5001412827126326,
                roll: 6.283185307179586
            },
        )
    }
}, {
    deep: true
})

const photoVisible = ref(false)
const photoIndex = ref(0)

const imgBtn = (num: number) => {
    photoVisible.value = true
    photoIndex.value = num
}

const alertVisible = ref(false)
const orgid = localStorage.getItem("orgid") || "";

const AlertBtn = () => {
    if (airObj.value) {
        alertVisible.value = true
        ElMessage.warning('准备出警，请稍后')
        clickAlert({ longitude: popList.value.lng, latitude: popList.value.lat, sn: popList.value.gatewaySn, height: "150", orgId: orgid }).then(res => {

        }).finally(() => {

        })
    } else {
        ElMessage.warning('当前位置附近没有可用设备')
    }
}

const messageHandler = async (payload: any) => {
    // console.info(payload)
    if (!payload) {
        return
    }
    // console.log('ws messages: ', payload)
    switch (payload.biz_code) {
        case EBizCode.DeviceUpgrade: {
            emitter.emit('deviceUpgrade', payload)
            break
        }
        case EBizCode.DeviceLogUploadProgress: {
            emitter.emit('deviceLogUploadProgress', payload)
            break
        }
        case EBizCode.GatewayOsd: {
            //   store.commit('SET_GATEWAY_INFO', payload.data)
            await store.other.useMyStore().SetGatewayInfo(payload.data)
            break
        }
        case EBizCode.DeviceOsd: {
            //   store.commit('SET_DEVICE_INFO', payload.data)
            await store.other.useMyStore().SetDeviceInfo(payload.data)
            break
        }
        case EBizCode.DockOsd: {
            // store.commit('SET_DOCK_INFO', payload.data)
            await store.other.useMyStore().SetDockInfo(payload.data)
            break
        }
        // case EBizCode.MapElementCreate: {
        //   store.commit('SET_MAP_ELEMENT_CREATE', payload.data)
        //   break
        // }
        // case EBizCode.MapElementUpdate: {
        //   store.commit('SET_MAP_ELEMENT_UPDATE', payload.data)
        //   break
        // }
        // case EBizCode.MapElementDelete: {
        //   store.commit('SET_MAP_ELEMENT_DELETE', payload.data)
        //   break
        // }
        case EBizCode.DeviceOnline: {
            //   store.commit('SET_DEVICE_ONLINE', payload.data)
            await store.other.useMyStore().SetDeviceOnline(payload.data)
            break
        }
        case EBizCode.DeviceOffline: {
            //   store.commit('SET_DEVICE_OFFLINE', payload.data)
            await store.other.useMyStore().SetDeviceOffline(payload.data)
            break
        }
        case EBizCode.FlightTaskProgress:
        case EBizCode.FlightTaskMediaProgress:
        case EBizCode.FlightTaskMediaHighestPriority: {
            emitter.emit('flightTaskWs', payload)
            break
        }
        case EBizCode.DeviceHms: {
            //   store.commit('SET_DEVICE_HMS_INFO', payload.data)
            await store.other.useMyStore().SetDeviceHmsInfo(payload.data)
            break
        }
        // case EBizCode.DeviceReboot:
        // case EBizCode.DroneOpen:
        // case EBizCode.DroneClose:
        // case EBizCode.CoverOpen:
        // case EBizCode.CoverClose:
        // case EBizCode.PutterOpen:
        // case EBizCode.PutterClose:
        // case EBizCode.ChargeOpen:
        // case EBizCode.ChargeClose:
        // case EBizCode.DeviceFormat:
        case EBizCode.DroneFormat: {
            // store.commit('SET_DEVICES_CMD_EXECUTE_INFO', {
            //   biz_code: payload.biz_code,
            //   timestamp: payload.timestamp,
            //   ...payload.data,
            // })
            await store.other.useMyStore().SetDeviceCmdExecuteInfo({
                biz_code: payload.biz_code,
                timestamp: payload.timestamp,
                ...payload.data,
            })
            break
        }
        case EBizCode.ControlSourceChange:
        case EBizCode.FlyToPointProgress:
        case EBizCode.TakeoffToPointProgress:
        case EBizCode.JoystickInvalidNotify:
        case EBizCode.DrcStatusNotify: {
            emitter.emit('droneControlWs', payload)
            break
        }
        default:
            break
    }
}

// 加载机场位置
useConnectWebSocket(messageHandler)

const onDestroyed = (e: any) => {
    emit('destroyed', e)
    // 销毁名称 overlay
    // clearMouseOverlayLabel()
}

const warningIcon = ref()
watch(() => store.informationListStore.informationStore().warningIcon, (data: any, oldVal) => {
    warningIcon.value = data
    if (!warningIcon.value.length) {
        popShow.value = false
    }
}, {
    deep: true
})

const handleWarningClick = (item: any) => {
    popShow.value = !popShow.value
    if (popShow.value) {
        console.log(item)
        popList.value = item
        store.informationListStore.informationStore().setWaringList(popList.value)
        getNearbyList({ longitude: popList.value.lng, latitude: popList.value.lat }).then(res => {
            if (res.tempJob.length) {
                // ElMessage.warning('当前位置附近没有可用设备')
                return
            } else {
                deviceOption.value = res
                console.log(deviceOption.value)
            }
        }).catch(() => {
            return
        })
        watchDeviceState = watch(() => store.other.useMyStore().deviceState, (data, oldVal) => {
            // console.log(data)
            if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[data.currentSn]) {
                // console.log('设备状态:', data.deviceInfo)
                deviceInfo.device = data.deviceInfo[popList.value.aircraftSn]
            }
            if (data.currentType === DeviceTypeName.Dock && data.dockInfo[popList.value.gatewaySn]) {
                // console.log('机场状态:', data.dockInfo[popList.value.gatewaySn])
                deviceInfo.dock = data.dockInfo[popList.value.gatewaySn]
                airObj.value = data.dockInfo[popList.value.gatewaySn]
            }
        }, {
            deep: true
        })
    } else {
        popList.value = null
        if (watchDeviceState) {
            watchDeviceState()
        }
    }
}

const popList = ref()
const popShow = ref(false)
const str = '--'

const deviceInfo: any = reactive({
    gateway: {
        capacity_percent: str,
        transmission_signal_quality: str,
    },
    dock: {

    },
    device: {
        gear: -1,
        mode_code: EModeCode.Disconnected,
        height: str,
        home_distance: str,
        horizontal_speed: str,
        vertical_speed: str,
        wind_speed: str,
        wind_direction: str,
        elevation: str,
        position_state: {
            gps_number: str,
            is_fixed: 0,
            rtk_number: str
        },
        battery: {
            capacity_percent: str,
            landing_power: str,
            remain_flight_time: 0,
            return_home_power: str,
        },
        latitude: 0,
        longitude: 0,
    }
})

// 无人机状态
const theEModeCode = reactive(['待机', '准备中', '已准备', '手动', '自动', '航点', '全景', '运行轨迹', 'ADS_B', '返航', '着陆', '强制着陆', '三叶着陆', '升级中', '未开机', "APAS", "虚拟摇杆状态", "指令飞行", "空中 RTK 收敛模式", "机场选址中", "POI环绕"])

let watchDeviceState: any
const airObj = ref()
const deviceOption = ref()
watch(() => store.informationListStore.informationStore().mapPopActive, (data: any, oldVal) => {
    popList.value = store.informationListStore.informationStore().waringList
    popShow.value = data
    console.log(popList.value)
    if (popShow.value) {
        getNearbyList({ longitude: popList.value.lng, latitude: popList.value.lat }).then(res => {
            if (res.tempJob.length) {
                // ElMessage.warning('当前位置附近没有可用设备')
                return
            } else {
                deviceOption.value = res
                console.log(deviceOption.value)
            }
        }).catch(() => {
            return
        })
        watchDeviceState = watch(() => store.other.useMyStore().deviceState, (data, oldVal) => {
            // console.log(data)
            if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[data.currentSn]) {
                // console.log('设备状态:', data.deviceInfo)
                deviceInfo.device = data.deviceInfo[popList.value.aircraftSn]
            }
            if (data.currentType === DeviceTypeName.Dock && data.dockInfo[popList.value?.gatewaySn]) {
                // console.log('机场状态:', data.dockInfo[popList.value.gatewaySn])
                deviceInfo.dock = data.dockInfo[popList.value.gatewaySn]
                airObj.value = data.dockInfo[popList.value.gatewaySn]
            }
        }, {
            deep: true
        })
    } else {
        if (watchDeviceState) {
            watchDeviceState()
        }
    }
}, {
    deep: true
})
const airportList: any = ref([])
const routeList: any = ref([])
const airSn: any = ref()
const airportBtn = (list: any) => {
    console.log(list)
    if (!airSn.value) {
        airSn.value = list.deviceSn
    } else {
        airSn.value = ""
    }
}
watch(() => route, (data: any, oldVal) => {
    console.log(data)
    if (data.path == "/monitor") {
        lengedActive.value = false
        airportBtn({
            deviceSn: route.query.deviceSn
        })
    } else if (data.path == "/flightList") {
        lengedActive.value = true
        airportBtn({
            deviceSn: route.query.deviceSn
        })
    }
}, {
    deep: true,
    immediate: true
})

function GetQueryString(name: any) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
    let context = '';
    if (r) context = r[2];
    return context ? context : '';
}

onMounted(() => {
    if (sessionStorage.getItem("type") && sessionStorage.getItem("type") == "1" || sessionStorage.getItem("type") == "2") {
        roadActive.value = false
    } else if (sessionStorage.getItem("type") && sessionStorage.getItem("type") == "0") {
        shippingActive.value = true
    }
})
onUnmounted(() => {
    viewerRef.value?.unload()
})

</script>

<template>
    <vc-config-provider :cesium-path="cesiumPath" :access-token="accesstToken">
        <vc-viewer ref="viewerRef" class="main-viewer" v-if="viewerShow" :show-credit="showCredit"
            :imagery-provider="false" :info-box="infoBox" @ready="onViewerReady" @cesium-ready="onCesiumReady">
            <vc-terrain-provider-cesium ref="provider"></vc-terrain-provider-cesium>
            <!-- 请求进度条 -->
            <vc-ajax-bar position="bottom" color="#21BA45" size="3px" positioning="fixed"></vc-ajax-bar>
            <!-- 底图图层 & 叠加图层 -->
            <template v-for="(item, index) in layerList" :key="'layer' + index">
                <component :is="item.component" v-bind="item.props">
                    <template v-for="(subItem, subIndex) in item?.children" :key="index + '_' + subIndex">
                        <component :is="subItem.component" v-bind="subItem.props" />
                    </template>
                </component>
            </template>
            <!-- 地形图层 -->
            <!-- <vc-terrain-provider-tianditu ref="provider" token="436ce7e50d27eede2f2929307e6b33c0"></vc-terrain-provider-tianditu> -->
            <template v-for="(item, index) in terrainLayers" :key="'terrain' + index">
                <component :is="item.component" v-if="item.props.show" v-bind="item.props" />
            </template>

            <!-- 循环创建河流 -->
            <template v-for="item in riverArray">
                <vc-primitive :appearance="riverAppearance">
                    <vc-geometry-instance>
                        <vc-geometry-polygon :polygonHierarchy="item.geometry.coordinates[0]"
                            :vertexFormat="riverVertexFormat"></vc-geometry-polygon>
                    </vc-geometry-instance>
                </vc-primitive>
            </template>

            <!-- 循环创建面禁飞区 -->
            <template v-for="item in noflyData" v-if="noflyShow">
                <vc-entity ref="noflyEntityRef" v-if="noflyData.length">
                    <vc-graphics-polygon ref="polygon" :hierarchy="item" :material="[255, 0, 0, 50]" :height="1"
                        :outline="true" outlineColor="#ff0000" :arcType="2"></vc-graphics-polygon>
                </vc-entity>
            </template>

            <!-- 循环创建面限高区 -->
            <template v-for="item in limitHeighData" v-if="limitHeighShow">
                <vc-entity ref="limitHeighRef" v-if="limitHeighData.length">
                    <vc-graphics-polygon ref="polygon" :hierarchy="item" :material="[255, 255, 255, 50]" :height="1"
                        :outline="true" outlineColor="#ffffff" :arcType="2"></vc-graphics-polygon>
                </vc-entity>
            </template>

            <!-- 船标 -->
            <template v-for="item in shipMarkers">
                <vc-entity ref="shipEntityRef" v-if="shipMarkers.length" :position="[item.longitude, item.latitude, 10]"
                    @click="handleBillboardClick(item)">
                    <vc-graphics-billboard ref="billboard" :image="shipImage" :width="15" :height="30"
                        :pixelOffset="[0, 0]" :rotation="item.trueHeading - 4.5"></vc-graphics-billboard>
                </vc-entity>
            </template>

            <!-- 船标弹窗 -->
            <div v-if="shipActive" class="mainBox">
                <div class="title">
                    <span>{{ shipList.shipNameCn ? shipList.shipNameCn : "--" }}</span>
                    <div class="op-btn-group">
                        <p class="op-button close-button lt-rotate-btn" @click="closeBtn">
                            <img :src="closePng" alt="">
                        </p>
                    </div>
                </div>

                <div class="tab-panels">
                    <div class="panel active">
                        <div class="ship-base-info">
                            <div class="body">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <td colspan="2">
                                                <span class="label">AIS船名：</span>
                                                <span class="text" v-if="shipList.name || shipList.shipNameCn">{{
                                                    shipList.name }}
                                                    {{ shipList.shipNameCn }}</span>
                                                <span class="text" v-else>--</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span class="label">MMSI：</span>
                                                <span class="text">{{ shipList.mmsi ? shipList.mmsi : "--" }}</span>
                                            </td>
                                            <td>
                                                <span class="label">船首向：</span>
                                                <span class="text">{{ shipList.trueHeading ? shipList.trueHeading +
                                                    "°"
                                                    :
                                                    "--" }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span class="label">长度：</span>
                                                <span class="text">{{ shipList.length ? shipList.length + "m" :
                                                    "--" }}</span>
                                            </td>
                                            <td>
                                                <span class="label">宽度：</span>
                                                <span class="text">{{ shipList.length ? shipList.length + "m"
                                                    : "--" }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span class="label">呼号：</span>
                                                <span class="text">{{ shipList.callSign ? shipList.callSign :
                                                    "--" }}</span>
                                            </td>
                                            <td>
                                                <span class="label">船迹向：</span>
                                                <span class="text">{{ shipList.cog ? shipList.cog + "°" : "--" }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span class="label">IMO：</span>
                                                <span class="text" v-if="shipList.imo != 0">{{ shipList.imo }}</span>
                                                <span class="text" v-else>--</span>
                                            </td>
                                            <td>
                                                <span class="label">航速：</span>
                                                <span class="text">{{ shipList.sog ? shipList.sog + "节" : "--" }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span class="label">类型：</span>
                                                <span class="text">{{ shipList.shipTypeCn ? shipList.shipTypeCn :
                                                    "--" }}</span>
                                            </td>
                                            <td>
                                                <span class="label">目的地：</span>
                                                <span class="text">{{ shipList.destination ? shipList.destination :
                                                    "--" }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span class="label">纬度：</span>
                                                <span class="text">{{ shipList.latitude ? shipList.latitude :
                                                    "--" }}</span>
                                            </td>
                                            <td>
                                                <span class="label">经度：</span>
                                                <span class="text">{{ shipList.longitude ? shipList.longitude :
                                                    "--" }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span class="label">预到时间：</span>
                                                <span class="text">{{ shipList.eta ? formatTimestamp(shipList.eta) :
                                                    "--" }}</span>
                                            </td>
                                            <td>
                                                <span class="label">更新时间：</span>
                                                <span class="text">{{ shipList.updatedAt ?
                                                    formatTimestamp(shipList.updatedAt) :
                                                    "--" }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 航标 -->
            <template v-for="item in markerList" v-if="markerActive">
                <vc-entity ref="navigationEntityRef" :position="[item.centralPointLng, item.centralPointLat, 0]"
                    @click="navigationBtn(item)">
                    <vc-graphics-billboard ref="billboard" :image="ossMarkImage" :width="41" :height="71"
                        :pixelOffset="[0, 0]"></vc-graphics-billboard>
                    <vc-graphics-label :text="item.markName" font="16px sans-serif" :pixelOffset="[20, -20]"
                        fillColor="white" :showBackground="true" :horizontalOrigin="1"
                        backgroundColor="rgba(0, 60, 135, 0.7)"></vc-graphics-label>
                </vc-entity>
                <vc-entity ref="markEntityRef" :position="[item.centralPointLng, item.centralPointLat, 0]"
                    v-if="item.markId === markId">
                    <vc-graphics-billboard ref="billboard2" :image="item.ossMarkImage" :width="150" :height="90"
                        :pixelOffset="[0, -120]"></vc-graphics-billboard>

                </vc-entity>
            </template>

            <wayline-waypoints-layer :viewer="readyViewer" />

            <!-- 无人机以及机场位置 -->
            <template v-for="item in airOptions">
                <vc-entity ref="entity" v-if="airOptions.length > 0" @click="airportBtn(item)"
                    :position="[item.longitude, item.latitude, 10]">
                    <vc-graphics-billboard ref="billboard" :image="indicatorImage3" :width="60" :height="78"
                        :pixelOffset="[0, -50]"></vc-graphics-billboard>
                </vc-entity>
                <vc-entity v-if="item.deviceSn == airSn" :position="[item.longitude, item.latitude, 0]">
                    <!-- <vc-graphics-ellipse :semiMinorAxis="250" :semiMajorAxis="250" :height="50" :material="[255, 0, 0, 125]"></vc-graphics-ellipse> -->
                    <vc-graphics-ellipse :semiMinorAxis="3000" :semiMajorAxis="3000" :height="50"
                        :material="[0, 255, 105, 45]"></vc-graphics-ellipse>
                </vc-entity>
                <vc-overlay-html ref="html" v-if="item.deviceSn == airSn"
                    :position="[item.longitude, item.latitude, 10]" :pixelOffset="[50, -100]">
                    <div class="airInfo">
                        <p> {{ item.deviceName }}</p>
                        <p>{{ item.nickName }}</p>
                        <p>机场状态：
                            <span :style="dockInfo?.[item.deviceSn]?.basicOsd?.mode_code === EDockModeCode.Remote_Debugging
                                ? 'color: #FED91B'
                                : dockInfo?.[item.deviceSn]?.basicOsd?.mode_code !== undefined &&
                                    dockInfo?.[item.deviceSn]?.basicOsd?.mode_code !== EDockModeCode.Disconnected
                                    ? 'color: #00FFAE'
                                    : 'color: #FF4545'">
                                {{
                                    theEDockModeCode[(dockInfo?.[item.deviceSn]?.basicOsd?.mode_code ??
                                        EDockModeCode.Disconnected) + 1]
                                }}
                            </span>
                        </p>
                        <p style="font-size: 12px;display: flex;align-items: center;">
                            <img style="width: 18.75px;height: 18.75px;margin-right: .5vw;"
                                src="@/assets/icons/lnglat.png" alt="">
                            {{ item.longitude }}°E,{{
                                item.latitude }}°N
                        </p>
                    </div>
                </vc-overlay-html>
            </template>
            <template v-for="item in routeList">
                <vc-entity ref="routeEntity" v-if="routeList.length > 0" :orientation="airBtn(item)"
                    :position="[item.longitude, item.latitude, 15]">
                    <vc-graphics-model ref="model" uri="/CesiumDrone.glb" :minimumPixelSize="80"></vc-graphics-model>
                </vc-entity>
            </template>

            <gengcundou-bridge-layer :viewer="readyViewer" :viewer-ready="!!readyViewer" />

            <!-- 预警点位 -->
            <template v-for="item in warningIcon">
                <vc-entity ref="entity" v-if="warningIcon.length > 0" @click="handleWarningClick(item)"
                    :position="[item.lng, item.lat, 30]">
                    <vc-graphics-billboard ref="billboard" :image="warningImage" :width="54" :height="59"
                        :pixelOffset="[0, 0]"></vc-graphics-billboard>
                </vc-entity>
            </template>
            <!-- 预警弹窗 -->
            <vc-overlay-html ref="html" :position="[Number(popList.lng) - 0.0005, Number(popList.lat), 0]"
                v-if="popShow" :pixelOffset="[-140, -500]">
                <div class="mapPopUp">
                    <div class="left-warning">
                        <div class="word-list">
                            <p v-if="!deviceOption" style="position: absolute;left: 17.5rem;top: 7.81rem;color: red;">
                                当前无人机不能出警</p>
                            <p>事件类型：{{ popList.eventType }}</p>
                            <p>发生地点：{{ popList.name }}</p>
                            <p>发生时间：{{ popList.eventTime }}</p>
                            <p>事件照片：</p>
                        </div>
                        <div class="imgBox" v-if="popList.eventImages.length">
                            <el-carousel class="swiper_box" :autoplay="false" trigger="click">
                                <el-carousel-item class="box" v-for="(item, index) in popList.eventImages.slice(0, 8)"
                                    :key="index">
                                    <img :src="item.image" alt="" @click="imgBtn(index)">
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div class="imgWord" @click="AlertBtn" v-if="deviceOption && deviceOption[0].sn_name">
                            <img src="@/assets/images/chujing.png" alt="">
                        </div>
                    </div>
                    <div class="right-warning">
                        <p class="title">出警附近机场：</p>
                        <p class="word">
                            <span>名称：</span>
                            <span :title="deviceOption ? deviceOption[0].sn_name : '--'">{{ deviceOption ?
                                deviceOption[0].sn_name :
                                "--" }}</span>
                        </p>
                        <p class="word">
                            <span>电量：</span>
                            <span>{{ deviceInfo.device && deviceInfo.device.battery.capacity_percent !== str ?
                                deviceInfo.device?.battery.capacity_percent + ' %' : str }}</span>
                        </p>
                        <p class="word">
                            <span>状态：</span>
                            <span>{{ airObj ?
                                theEModeCode[airObj.basicOsd?.mode_code] :
                                theEModeCode[EModeCode.Disconnected] }}</span>
                        </p>
                        <p class="word">
                            <span>风速：</span>
                            <span>{{ airObj ? airObj.basicOsd?.wind_speed : 0 }}</span>
                        </p>
                        <p class="word">
                            <span>降雨量：</span>
                            <span>{{ airObj ? airObj.basicOsd?.rainfall : 0 }}</span>
                        </p>
                    </div>
                </div>
            </vc-overlay-html>
            <slot />
        </vc-viewer>

        <photo-pop v-model:photoVisible="photoVisible" :photoIndex="photoIndex" />
        <alert-pop v-model:alertVisible="alertVisible" :sn="popList ? popList.gatewaySn : ''"
            :deviceSn="airObj ? airObj.basicOsd?.sub_device.device_sn : ''" />

        <!-- 图例 -->
        <!-- <div class="shrinkIcon" @click="shrinkBtn">
            <img src="@/assets/icons/shousuo-icon.png" alt="">
        </div>
        <div class="button-box" v-if="shrinkActive">
            <div class="air-box">
                <div class="air-list">
                    <p>
                        <img src="@/assets/images/map-uav.png" alt="">
                    </p>
                    <p>机场</p>
                </div>
                <div class="air-list">
                    <p>
                        <img src="@/assets/images/map-jichang.png" alt="">
                    </p>
                    <p>无人机</p>
                </div>
            </div>
            <div class="dimension-box flex-display flex-column flex-justify-around flex-align-center">
                <div class="dimension-list flex-display flex-align-center" @click="shipShowBtn">
                    <div style="width: 2.2vw;height: 3.9vh;" class="flex-display flex-justify-center">
                        <p style="width: 0.6vw;height: 3.6vh;">
                            <img src="@/assets/images/map-hangbiao.png" alt="">
                        </p>
                    </div>
                    <p>船舶</p>
                </div>
                <div class="dimension-list flex-display flex-align-center" @click="navigationShowBtn">
                    <div style="width: 2.1vw;height: 3.4vh;" class="flex-display flex-justify-center">
                        <p style="width: 2.1vw;height: 3.4vh;">
                            <img src="@/assets/images/map-ship.png" alt="">
                        </p>
                    </div>
                    <p>航标</p>
                </div>
                <div class="dimension-list flex-display flex-align-center">
                    <div style="width: 1.8vw;height: 3.2vh;" class="flex-display flex-justify-center">
                        <p style="width: 1.8vw;height: 3.2vh;">
                            <img src="@/assets/images/map-shigong.png" alt="">
                        </p>
                    </div>
                    <p>施工</p>
                </div>
            </div>
            <div class="air-box">
                <div class="air-list" style="cursor: pointer;" @click="noflyBtn">
                    <p style="width: 1.8vw;height: 3.2vh;margin: 5px auto;">
                        <img src="@/assets/images/jinfei.png" alt="">
                    </p>
                    <p>禁飞区</p>
                </div>
                <div class="air-list" style="cursor: pointer;" @click="limitHeighBtn">
                    <p style="width: 1.8vw;height: 3.2vh;margin: 5px auto;">
                        <img src="@/assets/images/xiangao.png" alt="">
                    </p>
                    <p>限高区</p>
                </div>
            </div>
        </div> -->

        <div class="layertoolbox" v-if="lengedActive">
            <div class="layer_list" :class="layerListSelect ? 'active' : ''">
                <div className="layer_list_item">
                    <div>
                        <img src="@/assets/icons/xiangao.png" />
                        <span className="layer_list_item_name">限高区</span>
                    </div>
                    <el-switch class="switchbox" inline-prompt active-text="开" inactive-text="关"
                        v-model="limitHeightChecked" @change="(value: any) => limitHeighBtn()" />
                </div>
                <div className="layer_list_item">
                    <div>
                        <img src="@/assets/icons/xianfei.png" />
                        <span className="layer_list_item_name">禁飞区</span>
                    </div>
                    <el-switch class="switchbox" inline-prompt active-text="开" inactive-text="关" v-model="noFlyChecked"
                        @change="(value: any) => noflyBtn()" />
                </div>

                <div className="layer_list_item" v-if="roadActive">
                    <div>
                        <img src="@/assets/icons/shiliangditu.png" />
                        <span className="layer_list_item_name">水上巡检区</span>
                    </div>
                    <el-switch class="switchbox" inline-prompt active-text="开" inactive-text="关" v-model="layerChecked"
                        @change="(value: any) => layerCheckedBtn()" />
                </div>
                <div className="layer_list_item" v-if="shippingActive">
                    <div>
                        <img src="@/assets/icons/hb-pic.png" />
                        <span className="layer_list_item_name">航标</span>
                    </div>
                    <el-switch class="switchbox" inline-prompt active-text="开" inactive-text="关"
                        v-model="navigationShow" @change="(value: any) => navigationShowBtn()" />
                </div>
            </div>
        </div>
    </vc-config-provider>
</template>

<style lang="scss">
.vc-html-container {
    z-index: 1 !important;
}

</style>
